import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { makeStyles, useTheme, Theme } from '@material-ui/core';


let useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3)
  }
}));

let Page = (props: any) => {
  let { children } = props;
  let theme = useTheme();
  let classes = useStyles(theme);

  return (
    <Fragment>
      <Helmet defaultTitle="Videndum Media Solutions" />

      <div className={classes.root}>
        {children}
      </div>
    </Fragment>
  );
};

export default Page;